import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';

// Set gaze region attribute on body element before DOMContentLoaded
// This ensures proper eye tracking initialization
document.body.setAttribute('data-gaze-region', 'false');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
